import MemberSettingsRenderer from "@components/utils/MemberSettingsRenderer";
import { OnboardingDialogStep } from "@components/utils/OnboardingDialog/constants";
import { Paths } from "@constants/paths";
import { _MemberSettingOnboardDialogLayout } from "@types";
import { MemberSettingFundingMode } from "kz-ui-sdk";
import { lazy, Suspense } from "react";
import { useNavigate } from "react-router-dom";

const LazyBankAccountStep = lazy(() => import("../BankAccountStep"));
const LazyBankLegalNameStep = lazy(() => import("../BankLegalNameStep"));
const LazyLegalNameStep = lazy(() => import("../LegalNameStep"));

interface PostLoginInfoStepProps {
  step: OnboardingDialogStep;
  stepNavigate: (step: OnboardingDialogStep) => void;
  handleClose: () => void;
  layout: _MemberSettingOnboardDialogLayout;
  callback?: () => void;
}

const PostLoginInfoStep = ({ step, stepNavigate, handleClose, layout, callback }: PostLoginInfoStepProps) => {
  const routerNavigate = useNavigate();

  const handleOnUpdateSuccess = () => {
    if (callback) {
      callback();
    }
    routerNavigate(Paths.PRIVATE.HOME);
  };

  return (
    <>
      {/*Funding Mode: BankOnly*/}
      <MemberSettingsRenderer
        feature="fundingMode"
        match={MemberSettingFundingMode.BankOnly}
      >
        {[OnboardingDialogStep.UpdateBankAccount, OnboardingDialogStep.AddBankAccount].includes(step) && (
          <Suspense>
            <LazyBankAccountStep
              navigate={stepNavigate}
              onUpdateSuccess={handleOnUpdateSuccess}
              handleClose={handleClose}
              layout={layout}
              step={step}
            />
          </Suspense>
        )}
      </MemberSettingsRenderer>

      {/*Funding Mode: EWalletOnly*/}
      <MemberSettingsRenderer
        feature="fundingMode"
        match={MemberSettingFundingMode.EWalletOnly}
      >
        {/*LEGAL NAME STEP*/}
        {[OnboardingDialogStep.UpdateLegalName, OnboardingDialogStep.AddLegalName].includes(step) && (
          <Suspense>
            <LazyLegalNameStep
              navigate={stepNavigate}
              handleClose={handleClose}
              onUpdateSuccess={handleOnUpdateSuccess}
              layout={layout}
              step={step}
            />
          </Suspense>
        )}
      </MemberSettingsRenderer>

      {/*Funding Mode: BankAndEWallet*/}
      <MemberSettingsRenderer
        feature="fundingMode"
        match={MemberSettingFundingMode.BankEWallet}
      >
        {[OnboardingDialogStep.UpdateBankLegalName, OnboardingDialogStep.AddBankLegalName].includes(step) && (
          <Suspense>
            <LazyBankLegalNameStep
              navigate={stepNavigate}
              onUpdateSuccess={handleOnUpdateSuccess}
              handleClose={handleClose}
              layout={layout}
              step={step}
            />
          </Suspense>
        )}
      </MemberSettingsRenderer>
    </>
  );
};

export default PostLoginInfoStep;
